const pattern = re => (value) => {
  const regex = new RegExp(re);
  return value && regex.test(value.toString());
};

export default pattern;
